import React from 'react';

const SelectWrapper = (props) => {
    return (
        <label className={`selectWrapper ${props.className && props.className}`}>
            {props.children}
        </label>
    );
};

export default SelectWrapper
